import { render, staticRenderFns } from "./PurchaseNeeded.vue?vue&type=template&id=ceeadd42&"
import script from "./PurchaseNeeded.vue?vue&type=script&lang=js&"
export * from "./PurchaseNeeded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports